import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@css/index.css'

import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)
import 'default-passive-events'

Vue.config.productionTip = false

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import common from '@/utils/common'
Vue.prototype.$common = common;

// 引入指令
import directive from '@/utils/directive';
Vue.use(directive)

import dragresize from 'v-dragresize';
Vue.use(dragresize);

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
